import { useEffect } from "react";

function useOutsideAlerter(ref, callback) {
  useEffect(
    () => {
      /**
       * Fire callback if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          callback && callback();
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    },
    [ref, callback]
  );
}

export default useOutsideAlerter;
